import fetch from '@/utils/fetch'

// 根据题目的guid得到此题目的解题提示列表
export function getHintList (pguid) {
  return fetch({
    url: '/getHintList_manager',
    params: {
      pguid
    },
    method: 'get'
  })
}

export function getHintByGuid (guid) {
  console.log('guid---guid=' + guid)
  return fetch({
    url: '/getHintByGuid_manager',
    params: {
      guid
    },
    method: 'get'
  })
}

export function addNewHint (data) {
  return fetch({
    url: '/addNewHint',
    data,
    method: 'post'
  })
}

export function updateHintByGuid (data) {
  return fetch({
    url: '/updateHintByGuid',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_hint.js